import axios from "axios"
import { MessageBox, Message } from "element-ui";
const baseUrl = '/prod-api'
axios.defaults.baseURL = baseUrl
axios.interceptors.request.use(
  config => {

    const isToken = (config.headers || {}).isToken === false;
    const token = sessionStorage.getItem('token')
    // const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
    if (token && !isToken) {
      config.headers["Authorization"] = "Bearer " + token; // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    return Promise.reject(error);
  }
)

axios.interceptors.response.use(
  response => {
    if (response.status === 200) {

      //console.log(response, 'responseresponseresponse---------1111111111111111122222')
      if (response.data.message === 'token解析失败！' || response.data.message === '登录状态已过期' || response.message === '登录状态已过期') {
        MessageBox.confirm('登录状态已过期,您可以继续留在该页面,或者重新登录', "系统提示", {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          sessionStorage.removeItem('token');
          location.reload();
        });
      } else {
        // if(response.config?.method.toLowerCase() == 'get' && response.data?.flag == false){
        //   Message({
        //     message: response.data?.message || '服务未找到',
        //     duration: 2500,
        //     type: "error",
        //   });
        // }
        return response.data
      }
    } else {
      console.log(response);
    }

  },
  error => {
    let code = 0;
    try {
        code = error.response.status;
    } catch (e) {
        if (error.toString().indexOf("Error: timeout") !== -1) {
            Message({
                message: "网络请求超时",
                duration: 2500,
                type: "error",
            });
        }else if (error.toString().indexOf("Error: Network Error") !== -1) {
            Message({
                message: "网络请求错误",
                duration: 2500,
                type: "error",
            });
        } else if (code === 504) {
            Message({
                message: "服务器异常",
                duration: 2500,
                type: "error",
            });
        } else {
            const errorMsg = error.response.data.message;
            if (errorMsg !== undefined) {
                Message({
                    message: errorMsg,
                    duration: 3000,
                    type: "error",
                });
            }
        }
        return Promise.reject(error); 
    }
  }

)